import React from "react";

import BackGround from "components/common/BackGround";
import Gnb from "components/common/Gnb";
import Footer from "components/common/Footer";
import ContactTerm from "components/contactUs/ContactTerm";

export default function ContactUs() {
    return (
        <BackGround>
            <Gnb />
            <ContactTerm />
            <Footer />
        </BackGround>
    );
}